/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { Trans, translate } from 'react-i18next';

import styles from 'common-scss/DetailsPage.module.scss';

@translate()
@inject('assetStore')
@observer
export default class AssetAccessories extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    const asset: any = this.props.assetStore.asset;

    return (
      <div>
        <h3>{`${t('general:model')}: ${asset.model}`}</h3>
        <table className={`${styles['layout-table']} ${styles['large-first-col']}`}>
          <thead>
            <tr>
              <th style={{ width: '100%' }}>{t('general:accessories')}</th>
              <th style={{ whiteSpace: 'nowrap' }}>
                {t('general:assets.abbrs.quantity_delivered')}
              </th>
            </tr>
          </thead>
          <tbody>
            {asset.accessories.map((n: Object) => {
              return (
                <tr key={n.id}>
                  <td>{n.er_description}</td>
                  <td>{n.er_quantity}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Trans i18nKey="general:assets.rented_assets.messages.return_equipment">
          <b>{t('general:labels.please_note')}</b>
        </Trans>
      </div>
    );
  }
}
